export var TransactionType;
(function (TransactionType) {
    TransactionType["Accrual"] = "Accrual";
    TransactionType["WriteOff"] = "WriteOff";
})(TransactionType || (TransactionType = {}));
export var WalletType;
(function (WalletType) {
    WalletType["Teal"] = "Teal";
    WalletType["Thank"] = "Thank";
    WalletType["CafeteriaBenefits"] = "CafeteriaBenefits";
    WalletType["SupervisorBalance"] = "SupervisorBalance";
})(WalletType || (WalletType = {}));
export var TransactionCategoryType;
(function (TransactionCategoryType) {
    TransactionCategoryType["Activity"] = "Activity";
    TransactionCategoryType["Order"] = "Order";
    TransactionCategoryType["Emission"] = "Emission";
    TransactionCategoryType["Thanks"] = "Thanks";
    TransactionCategoryType["CafeteriaBenefits"] = "CafeteriaBenefits";
    TransactionCategoryType["ThanksCommission"] = "ThanksCommission";
    TransactionCategoryType["ThanksJoin"] = "ThanksJoin";
    TransactionCategoryType["ThanksJoinCommission"] = "ThanksJoinCommission";
    TransactionCategoryType["Achievement"] = "Achievement";
    TransactionCategoryType["EmissionBurndown"] = "EmissionBurndown";
    TransactionCategoryType["SupervisorThanks"] = "SupervisorThanks";
    TransactionCategoryType["InitialBalance"] = "InitialBalance";
    TransactionCategoryType["SurpriseBox"] = "SurpriseBox";
})(TransactionCategoryType || (TransactionCategoryType = {}));
export var TransactionCategoryFilterType;
(function (TransactionCategoryFilterType) {
    TransactionCategoryFilterType["Activity"] = "Activity";
    TransactionCategoryFilterType["Order"] = "Order";
    TransactionCategoryFilterType["Emission"] = "Emission";
    TransactionCategoryFilterType["Thanks"] = "Thanks";
    TransactionCategoryFilterType["CafeteriaBenefits"] = "CafeteriaBenefits";
    TransactionCategoryFilterType["Achievement"] = "Achievement";
    TransactionCategoryFilterType["SupervisorThanks"] = "SupervisorThanks";
    TransactionCategoryFilterType["InitialBalance"] = "InitialBalance";
    TransactionCategoryFilterType["EmissionBurndown"] = "EmissionBurndown";
    TransactionCategoryFilterType["SurpriseBox"] = "SurpriseBox";
})(TransactionCategoryFilterType || (TransactionCategoryFilterType = {}));
export var TransactionStatusType;
(function (TransactionStatusType) {
    TransactionStatusType["Confirmed"] = "Confirmed";
    TransactionStatusType["Canceled"] = "Canceled";
})(TransactionStatusType || (TransactionStatusType = {}));
export var TransactionFilterType;
(function (TransactionFilterType) {
    TransactionFilterType["ManagerList"] = "ManagerList";
    TransactionFilterType["MyProfileOperations"] = "MyProfileOperations";
})(TransactionFilterType || (TransactionFilterType = {}));
